<div class="no-permission-sys-admin">
    <img src="/assets/images/no-permission-background.png" alt="">

    <span>
        {{'SysAdmin.NoPermission' | translate}}
    </span>
</div>